import {
  RANKING_GET_REQUEST,
  RANKING_SET,
  RANKING_UNSET,
  RANKING_USER_GET_REQUEST,
  RANKING_USER_LOAD_REQUEST,
  RANKING_USER_SET,
  RANKING_USER_PAGE_CHANGE,
  RANKING_USER_LOAD_SET,
  RANKING_USER_STOP_LOAD,
  GET_CAMPAIGN_TEAM_RANKING_SUCCESS,
  GET_CAMPAIGN_TEAM_RANKING_ERROR,
  GET_CAMPAIGN_TEAM_RANKING_REQUESTING,
  LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS,
  LOAD_CAMPAIGN_TEAM_RANKING_ERROR,
  LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { IRankingReducer } from "./types";

const initialState: IRankingReducer = {
  requesting: false,
  loading: false,
  successful: false,
  error: "",
  campaignTeamRankingPage: 0,
  campaignTeamRanking: [],
  userRankingPage: 0,
  hasResult: true,
  rankingPage: 0,
  userRanking: [],
  ranking: [],
};

const reducer = function actionReducer(
  state: IRankingReducer = initialState,
  action,
): IRankingReducer {
  switch (action.type) {
    case RANKING_USER_GET_REQUEST:
    case RANKING_GET_REQUEST: {
      return {
        ...state,
        requesting: true,
      };
    }

    case LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING:
    case RANKING_USER_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case RANKING_USER_PAGE_CHANGE: {
      let hasResult = state.hasResult;
      if (!action.payload) {
        hasResult = true;
      }
      return {
        ...state,
        hasResult,
        userRankingPage: action.payload,
      };
    }

    case RANKING_USER_STOP_LOAD: {
      return {
        ...state,
        hasResult: false,
      };
    }

    case GET_CAMPAIGN_TEAM_RANKING_REQUESTING:
      return {
        ...state,
        hasResult: true,
        requesting: true,
      };

    case LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS:
      return {
        ...state,
        loading: false,
        campaignTeamRankingPage: state.campaignTeamRankingPage + 1,
        campaignTeamRanking: [...state.campaignTeamRanking, ...action.payload],
      };

    case LOAD_CAMPAIGN_TEAM_RANKING_ERROR:
      return {
        ...state,
        loading: false,
      };

    case GET_CAMPAIGN_TEAM_RANKING_SUCCESS:
      return {
        ...state,
        requesting: false,
        campaignTeamRankingPage: 1,
        campaignTeamRanking: action.payload,
      };

    case GET_CAMPAIGN_TEAM_RANKING_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case RANKING_USER_LOAD_SET:
      return {
        ...state,
        loading: false,
        userRankingPage: state.userRankingPage + 1,
        userRanking: state.userRanking.concat(action.payload),
      };

    case RANKING_SET:
      return {
        ...state,
        requesting: false,
        ranking: action.payload,
      };

    case RANKING_USER_SET:
      return {
        ...state,
        requesting: false,
        loading: false,
        userRanking: action.payload,
        userRankingPage: state.userRankingPage + 1,
      };

    case LOGOUT:
    case RANKING_UNSET:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
